import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "nonzero",
      d: "M20.122 18.318a6.624 6.624 0 1 0-1.804 1.804l2.504 2.504a1.276 1.276 0 1 0 1.804-1.804zm-5.492 1.399a5.087 5.087 0 1 1 0-10.174 5.087 5.087 0 0 1 0 10.174"
    }, null, -1)
  ]))]))
}
export default { render: render }